import useApi from './useApi';

const ENDPOINT = process.env.REACT_APP_ENVIRONMENT === 'production' ?
process.env.REACT_APP_BASE_URL_API_SERVER_PROD : 
process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useDeovitaApi = () => useApi(ENDPOINT);

export default useDeovitaApi;
